const USER_REFERRALS = {
    GETTING_REFERRALS: 'GETTING_REFERRALS',
    GET_REFERRALS_SUCCESS: 'GET_REFERRALS_SUCCESS',
    GET_REFERRALS_FAILURE: 'GET_REFERRALS_FAILURE',
    CLEAR_USER_REFERRALS: 'CLEAR_USER_REFERRALS'
};

export default USER_REFERRALS;